export const validateRecipeNetworkAddress = (data) => {
  const singleNetwork = new RegExp(/^[^;,\s]+$/);
  const networkFormat = new RegExp(
    /^([01]?\d\d?|2[0-4]\d|25[0-5])(?:\.[01]?\d\d?|\.2[0-4]\d|\.25[0-5]){3}(?:\/[0-2]?\d|\/3[0-2])?$/,
  );
  const specialChars = new RegExp(/^[0-9a-z.:/_\*-\s\[\]]+$/);
  let ret = null;

  if (data?.length > 0) {
    for (let i in data) {
      const network = data[i].replaceAll('[', '').replaceAll(']', '');

      if (!specialChars.test(network)) {
        ret = { valid: false, message: 'Special characters are not allowed.' };
      } else if (!singleNetwork.test(network)) {
        ret = {
          valid: false,
          message: 'Please use Enter to separate network addresses.',
        };
      } else if (!networkFormat.test(network)) {
        ret = { valid: false, message: 'Invalid network address format.' };
      } else {
        ret = { valid: true };
      }
    }
  } else {
    ret = { valid: false, message: 'Invalid network address format.' };
  }

  return ret;
};
